<div data-tmo-id="screenlock-spinner" [hidden]="showSpinner" [id]="'screen-lock-spinner-' + id">
  <!-- screenlock spinner -->
  <div class="screenlock" [ngClass]="{ 'white-spinner': spinnerTextMessage }">
    <div class="spinner">
      <i class="fa fa-spinner fa-pulse spinner-icon"></i>
      <div *ngIf="spinnerTextMessage">
        <h5>{{ spinnerTextMessage }}</h5>
      </div>
    </div>
  </div>
</div>
<!--/ div#screenlock-spinner -->
